import React from 'react';
import { Dialog } from './../../common/dialog';
import numeral from 'numeral';
import { dateToTimezone } from './../../../utils';

const SCTicket = React.memo((props) => {
    const hideHandler = () => {
        props.setIdModal(null);
        props.hideSCTicketModal();
    };

    let createButtonLabel = 'Create Ticket';
    if (props.isCreatingSCTicket) {
        createButtonLabel = <i className="fas fa-circle-notch fa-spin" />;
    }

    let actions = [
        <button key="cancel-button" className="btn btn-light btn-sm action-button-cancel" onClick={hideHandler}>Close</button>,
        <button key="action-button" className="btn btn-light btn-sm action-button" onClick={props.createSCTicket} disabled={props.isCreatingSCTicket}>
            {createButtonLabel}
        </button>
    ];

    const renderItems = () => {
        return props.scTicketSelectedItems.map((order) => {
            let cardFor = 'N/A';
            let quantity = numeral(order.quantity).format('0,0');
            if (order['variables'] && order['variables'] !== '') {
                let json = JSON.parse(order['variables']);
                if (json.name && json.name !== '') {
                    cardFor = json.name;
                }

                if (json.staticTemplateCode) {
                    quantity += (order.quantity > 1 ? ' bundles' : ' bundle');
                    quantity += ' (' + numeral(order.pieces_per * order.quantity).format('0,0') + ' pieces)';

                    if (parseInt(json['staticTemplateCode']) === 647) {
                        quantity = order.quantity;
                    } else if (parseInt(json['staticTemplateCode']) === 652) {
                        quantity = order.quantity;
                    }
                }
            }

            let orderedBy = order.user_name;
            if (order.cxmlPunchout != null) {
                const extrinsicData = JSON.parse(order.cxmlPunchout.extrinsic);
                let nameParts = [];
                if (extrinsicData.FirstName) {
                    nameParts.push(extrinsicData.FirstName);
                }
                if (extrinsicData.LastName) {
                    nameParts.push(extrinsicData.LastName);
                }
                orderedBy = nameParts.join(' ');
                if (orderedBy === '') {
                    orderedBy = 'Coupa';
                }
            }

            if (order['variables'] && order['variables'] !== '') {
                let json = JSON.parse(order['variables']);
                if (json.managerName && json.managerName !== '') {
                    orderedBy = 'Manager (' + json.managerName + ')';
                }
            }

            return (
                <tr>
                    <td>{order.uthealth_order_id}</td>
                    <td>{order.part_number}/{order.total_parts}</td>
                    <td>{order.billPo}</td>
                    <td>{quantity}</td>
                    <td>{cardFor}</td>
                    <td>{dateToTimezone(order.created_at, 'MM/DD/YYYY')}</td>
                    <td>{order.product_type}</td>
                    <td>{orderedBy}</td>
                    <td>{numeral(order.total_price).format('$0,0.00')}</td>
                </tr>
            );
        });
    };

    return (
        <Dialog
            name="sc-ticket-modal"
            modal={false}
            actions={actions}
            contentStyle={{ width: 1000 }}
            bodyStyle={{ overflow: 'initial' }}
            className="sc-ticket-dialog"
        >
            <div className="sc-ticket-container">
                <div className="title">Create StageCoach Ticket</div>
                <div className="content exists">
                    <p>Click on the <b>Create Ticket</b> button to create a SC Ticket for the selected items:</p>
                    <table className="table table-sm table-hover table-striped">
                        <thead>
                            <tr>
                                <th>Order #</th>
                                <th>Part</th>
                                <th>PO #</th>
                                <th>Qty</th>
                                <th>Card For</th>
                                <th>Ordered Date</th>
                                <th>Product</th>
                                <th>Ordered By</th>
                                <th>Total</th>
                            </tr>
                        </thead>
                        <tbody>{renderItems()}</tbody>
                    </table>
                </div>
            </div>
        </Dialog >
    );
});

export default SCTicket;
